import { Grid, GridItem, Heading } from '@chakra-ui/react';

export interface InquiryLoggingSummaryProps {
  subCode: string;
}

export const InquiryLoggingSummary = (props: InquiryLoggingSummaryProps) => {
  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={8}
        marginBottom={2}
        fontSize={'sm'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Inquiry Logging
      </Heading>
      <Grid templateColumns='repeat(5, 1fr)' gap={2}>
        <GridItem textAlign={'right'}>
          <strong>Subscriber Code for Inquiry Logging:</strong>
        </GridItem>
        <GridItem colSpan={4} marginLeft={1}>
          {props.subCode}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Inquiry Type:</strong>
        </GridItem>
        <GridItem colSpan={4} marginLeft={1}>
          Account Review
        </GridItem>
      </Grid>
    </>
  );
};
